import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StemSidebar from "./components/StemSidebar";
import "./stem.css";

export default function StemLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, []);

  const handleOverlayClick = () => setSidebarOpen(false);

  return (
    <>
      <div className="stem-shell">
        {/* Mobile backdrop */}
        {sidebarOpen && (
          <div className="stem-sidebar-overlay" onClick={handleOverlayClick} />
        )}

        {/* Mobile menu trigger */}
        <button
          type="button"
          className="stem-mobile-menu-trigger"
          onClick={() => setSidebarOpen(true)}
          title="Open menu"
        >
          <Menu size={18} strokeWidth={2} />
        </button>

        {/* Left Sidebar */}
        <StemSidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        {/* Main Content Area */}
        <div className="stem-main">
          {/* Child routed pages render here */}
          <main className="stem-content">
            <Outlet />
          </main>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </>
  );
}
